/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { WithRouterProps } from '@modules/routing/withRouter'
import withRouter from '@modules/routing/withRouter'

import { fetchSnapshotRepository } from '@/actions/snapshotRepositories'
import { fetchSnapshotRepositoryRequest } from '@/reducers/asyncRequests/registry'
import { getSnapshotRepository } from '@/reducers/snapshotRepositories'
import { getConfigForKey } from '@/selectors'

import EditSnapshotRepository from './EditSnapshotRepository'

import type { ReduxState } from '@/types/redux'

type RouteProps = {
  regionId: string | undefined
  repositoryId: string
}

const mapStateToProps = (
  state: ReduxState,
  { router: { params } }: WithRouterProps<RouteProps>,
) => {
  const { repositoryId, regionId: regionIdParam } = params
  const defaultRegionId = getConfigForKey(state, `DEFAULT_REGION`)
  const regionId = regionIdParam || defaultRegionId

  return {
    regionId,
    repositoryId,
    repository: getSnapshotRepository(state, regionId, repositoryId),
    fetchSnapshotRepositoryRequest: fetchSnapshotRepositoryRequest(state, regionId, repositoryId),
  }
}

export default withRouter(
  connect(mapStateToProps, {
    fetchSnapshotRepository,
  })(EditSnapshotRepository),
)
